import { AT_TYPES } from "./entity.js";

export const OPERATIONS = {
  // user
  LOGIN: "login",
  LOGIN_FEDERATED_LINK: "loginFederatedLink",
  LOGIN_FEDERATED_EXCHANGE: "loginFederatedExchange",
  REGISTER: "register",
  REFRESH_LOGIN: "refreshLogin",
  REVOKE_REFRESH: "revokeRefreshToken",
  VERIFY_EMAIL: "verifyEmail",
  RESET_PASSWORD: "resetPassword",
  // general
  CREATE: "create",
  CLONE: "clone",
  LIST: "list",
  UPDATE: "update",
  CONVERGE: "converge",
  VERIFY: "verify",
  LOCK: "lock",
  DELETE: "delete",
  ERROR: "error",
  TRIP: "trip",
  // invites
  ACCEPT: "accept",
  REJECT: "reject",
  // projects
  ADD_WORKSTATION: "add_workstation",
  ADD_DISPLAY_GATEWAY: "add_displaygateway",
  ADD_CONTAINER: "add_container",
  ADD_DATABASE: "add_database",
  ADD_NODE: "add_node",
  ADD_VPN_GATEWAY: "add_virtualprivatenetworkgateway",
  ADD_SNOWFLAKE: "add_snowflake",
  ADD_SSH_KEY: "add_sshkey",
  ADD_CONNECTION: "add_connection",
  ADD_SCHEDULE: "add_schedule",
  ADD_INVITEE: "add_invitee",
  ADD_USER: "add_user",
  ADD_ACTION: "add_action",
  ESTIMATE: "estimate",
  LIST_USERS: "list_users",
  // resources
  START: "start",
  STOP: "stop",
  CLONE_IMAGE: "clone",
  CREATE_IMAGE: "create_image",
  RESIZE: "resize"
};

export const ADD_RESOURCE_OPERATIONS = [
  OPERATIONS.ADD_WORKSTATION,
  OPERATIONS.ADD_DISPLAY_GATEWAY,
  OPERATIONS.ADD_CONTAINER,
  OPERATIONS.ADD_DATABASE,
  OPERATIONS.ADD_NODE,
  OPERATIONS.ADD_SNOWFLAKE,
  OPERATIONS.ADD_VPN_GATEWAY
];

export const ADD_RESOURCE_OPERATIONS_BY_TYPE = {
  [AT_TYPES.WORKSTATION]: OPERATIONS.ADD_WORKSTATION,
  [AT_TYPES.DISPLAY_GATEWAY]: OPERATIONS.ADD_DISPLAY_GATEWAY,
  [AT_TYPES.CONTAINER]: OPERATIONS.ADD_CONTAINER,
  [AT_TYPES.DATABASE]: OPERATIONS.ADD_DATABASE,
  [AT_TYPES.NODE]: OPERATIONS.ADD_NODE,
  [AT_TYPES.SNOWFLAKE]: OPERATIONS.ADD_SNOWFLAKE,
  [AT_TYPES.VPN_GATEWAY]: OPERATIONS.ADD_VPN_GATEWAY
};
